module.exports = __webpack_public_path__ + "img/signup_logo.8987e1c6.png";